import React from "react"

import * as styles from "./toggle.module.css"
import PlainButton from "./plain-button"
import { testIds } from "../common/constants"
import classNames from "classnames"

const Toggle = ({ className, onClick, active, bright = false }) => {
  const wrapperClass = classNames(className, styles.wrapper, {
    [styles.active]: active,
    [styles.bright]: bright,
  })
  return (
    <div className={wrapperClass}>
      <PlainButton
        onClick={onClick}
        className={`${styles.innerWrapper} ${active ? styles.active : ""}`}
        aria-label="Toggle navigation menu"
        data-test-id={testIds.global.header.navigation.toggle}
      >
        <span />
        <span />
        <span />
      </PlainButton>
    </div>
  )
}

export default Toggle
